module.exports = __webpack_public_path__ + "static/Reward_image-0c2019a44c2f42f2a5956b9790ccf9e3.png";